<template>
  <v-card min-height="600">
    <v-overlay absolute color="grey lighten-4" v-if="isLoading" opacity="1">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <v-card-text v-if="contract && !isLoading">
      <div class="flex items-center justify-between my-3">
        <h3>{{ $t('suspend.history_suspend_business') }}</h3>
        <v-btn
          color="info"
          elevation="0"
          @click="requireSuspend"
          :disabled="getContract.isSuspend"
        >
          <!-- v-show="contract.status && contract.status.code !== '001'" -->
          {{ $t('suspend.add_suspend_business') }}
          <v-icon right>mdi-hand-back-left</v-icon>
        </v-btn>
      </div>

      <template v-for="suspend of getContractSuspends">
        <card-suspend
          :suspend="suspend"
          :key="suspend.objectId"
          :type="suspend.type"
          :start-date="suspend.startDate.iso"
          :end-date="suspend.endDate.iso"
          :note="suspend.note"
          :status="suspend.isActive"
          @onEdit="editSuspendDialog(suspend)"
          @onView="viewSuspendDialog(suspend)"
          @onRemove="removeSuspend(suspend)"
          @onRemoved="removedSuspend(suspend)"
        ></card-suspend>
      </template>
      <div
        v-if="getContractSuspends.length == 0"
        class="flex justify-center py-10 text-gray-400"
        style="font-size:18px;"
      >{{ $t('suspend.no_history_suspend_business') }}</div>
    </v-card-text>
    <v-card-text class="text-center mt-10" v-else-if="!contract && !isLoading">
      <v-icon size="80">mdi-alert-circle-outline</v-icon>
      <h3 class="mt-4">{{ $t('contract.no_contract') }}</h3>
    </v-card-text>
    <form-suspend
      v-model="isSuspendDialog"
      @onSave="saveSuspend"
      @onSaveEdit="editSuspend"
      :isView="isView"
      :obj="suspendObject"
      :event="suspendEvent"
      :onFirst="onFirst"
      @onFirstDisabled="onFirst = false"
    ></form-suspend>
    <confirm-dialog
      @onOk="removeSuspendConfirm"
      v-model="isConfirm"
      :title="$t('suspend.you_want_to_cancel_suspend_business')"
      :loading="isLoading"
      :disabled="isLoading"
    ></confirm-dialog>
    <confirm-dialog
      @onOk="removedSuspendConfirm"
      v-model="isRemoved"
      :title="$t('suspend.you_delete_suspend_business')"
      :loading="isLoading"
      :disabled="isLoading"
    ></confirm-dialog>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import CardSuspend from "./CardSuspend.vue";
import FormSuspend from "./FormSuspend.vue";
import ConfirmDialog from "./ConfirmDialog.vue";
export default {
  components: {
    CardSuspend,
    FormSuspend,
    ConfirmDialog
  },
  props: {
    contract: {
      type: Object,
      default: {}
    },
    contractId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: false,
      isSuspendDialog: false,
      suspendEvent: "create",
      onFirst: true,
      suspendObject: {},
      isView: false,
      isConfirm: false,
      isRemoved: false
    };
  },
  watch: {
    contractId: {
      handler(value) {
        if (value) this.loadSuspend();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      getContractSuspends: "contractSuspend/getContractSuspends",
      getContract: "contract/getContract",
    })
  },
  methods: {
    async loadSuspend() {
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          "contractSuspend/getContractSuspendByContract",
          { contractId: this.contract.id }
        );
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    removeSuspend(object) {
      this.suspendObject = object;
      this.isConfirm = true;
    },
    removedSuspend(object) {
      this.suspendObject = object;
      this.isRemoved = true;
    },
    async removeSuspendConfirm() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("contractSuspend/removeContractSuspend", {
          id: this.suspendObject.objectId
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
      this.isConfirm = false;
      this.$emit("reloadContract");
    },
    async removedSuspendConfirm() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("contractSuspend/removedContractSuspend", {
          id: this.suspendObject.objectId
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
      this.isRemoved = false;
      this.$emit("reloadContract");
      this.$eventBus.$emit('updateAreaPlan')
    },
    editSuspendDialog(object) {
      this.isView = false;
      this.suspendEvent = "edit";
      this.onFirst = true;
      this.suspendObject = object;
      this.isSuspendDialog = true;
    },
    viewSuspendDialog(object) {
      this.isView = true;
      this.suspendEvent = "view";
      this.isSuspendDialog = true;
      this.suspendObject = object;
    },
    async saveSuspend(value) {
      this.isLoading = true;
      try {
        await this.$store.dispatch(
          "contractSuspend/createContractSuspend",
          value
        );
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
      this.$emit("reloadContract");
      this.$eventBus.$emit('updateAreaPlan')
    },
    async editSuspend(value) {
      await this.$store.dispatch("contractSuspend/editContractSuspend", value);
      this.$emit("reloadContract");
      this.$eventBus.$emit('updateAreaPlan')
    },
    requireSuspend() {
      this.isView = false;
      this.suspendEvent = "create";
      this.isSuspendDialog = true;
    }
  }
};
</script>